import { render, staticRenderFns } from "./VoIPCalls.vue?vue&type=template&id=c405df60&scoped=true&"
import script from "./VoIPCalls.vue?vue&type=script&lang=js&"
export * from "./VoIPCalls.vue?vue&type=script&lang=js&"
import style0 from "./VoIPCalls.vue?vue&type=style&index=0&id=c405df60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405df60",
  null
  
)

export default component.exports